import React from 'react';
import styled from 'styled-components';
import getPartners from '../../api/getPartners';

export default function Partners() {
  return (
    <Wrap>
      <Image src={getPartners[0]?.icon} />
      <Typography>Úvěry pro SVJ a DB jsou zajišťovány prostřednictvím TOMAN FINANCE GROUP s.r.o.</Typography>
    </Wrap>
  );
}

const Typography = styled.p`
  @media (min-width: 1024px) {
    grid-column: 7 / 13;
  }
`;

const Image = styled.img`
  @media (min-width: 1024px) {
    grid-column: 5 / 6;
  }
`;

const Wrap = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 12px;
  flex-flow: row wrap;

  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  & img {
    width: 80px;
    height: 65px;
    background: ${({ theme }) => theme.palette.common.white};
    margin: 0 2px;
    border-radius: 3px;
    box-shadow: 1px 3px 6px ${({ theme }) => theme.palette.black.light};
    margin-bottom: 12px;
  }
`;
